module.exports = __webpack_public_path__ + "img/2-hondenspeelgoed.2099077b.jpg";